import React from 'react';
import { isToday, parseISO, format } from 'date-fns';
import { useRecallReports } from '@/hooks/recall-report';
import { useAvailabilityReports } from '@/hooks/availability-report';
import { useAutoSendTime } from '@/hooks/recall-report/use-auto-send-time';
import { useSettingsQueries } from '@/hooks/settings';
import { CounterpartyCard } from './CounterpartyCard';
import { AddCounterpartyCard } from './AddCounterpartyCard';
import { DEFAULT_SEND_HOUR, DEFAULT_SEND_MINUTE } from '@/utils/report-format';

interface CounterpartyListProps {
  selectedCp: string;
  onSelect: (cpId: string) => void;
}

export const CounterpartyList: React.FC<CounterpartyListProps> = ({
  selectedCp,
  onSelect,
}) => {
  const { data: recallReports } = useRecallReports();
  const { data: availabilityReports } = useAvailabilityReports();
  const { data: settings } = useSettingsQueries();
  const counterparties = [{
    id: settings?.default_counterparty_id ?? 'velocity',
    name: settings?.default_counterparty_name ?? 'Velocity',
  }];
  const sendHour = settings?.velocity_reports_send_hour ?? DEFAULT_SEND_HOUR;
  const sendMinute = settings?.velocity_reports_send_minute ?? DEFAULT_SEND_MINUTE;
  const autoSendTarget = useAutoSendTime(sendHour, sendMinute);

  const sendTime = autoSendTarget ? format(autoSendTarget, 'HH:mm') : null;

  return (
    <div>
      <div className="px-3 pb-2 pt-4 text-xs font-semibold uppercase tracking-wider text-gray-500">
        Counterparties
      </div>
      <div className="space-y-2 px-3 pb-4">
        {counterparties.map((cp) => {
          const todayRecall = recallReports?.find(
            (r) =>
              r != null && r.counterparty === cp.id && isToday(parseISO(r.created_at))
          );
          const todayAvailability = availabilityReports?.find(
            (r) =>
              r != null && r.counterparty === cp.id && isToday(parseISO(r.created_at))
          );

          return (
            <CounterpartyCard
              key={cp.id}
              name={cp.name}
              availabilityStatus={todayAvailability?.status ?? null}
              recallStatus={todayRecall?.status ?? null}
              sendTime={sendTime}
              isSelected={selectedCp === cp.id}
              onClick={() => onSelect(cp.id)}
            />
          );
        })}
        <AddCounterpartyCard />
      </div>
    </div>
  );
};
